export default __webpack_public_path__ + "locales/fi/People.json?hash=8ee1cff70ebfb85ddc5afac141c3777e";